/**
 * imageUtils.js
 * Optimizes images for AI generation by resizing to a safe dimension.
 * Based on Lesson 42: Client-Side Resizing to prevent latency.
 */

export const resizeImageForAI = (input, maxWidth = 1024) => {
    return new Promise((resolve, reject) => {
        const isBlob = input instanceof Blob || input instanceof File;
        const url = isBlob ? URL.createObjectURL(input) : input;

        const img = new Image();
        img.crossOrigin = "Anonymous"; // Prevent tainted canvas
        img.src = url;

        img.onload = () => {
            let width = img.width;
            let height = img.height;

            // Calculate new dimensions
            if (width > maxWidth) {
                height = Math.round((height * maxWidth) / width);
                width = maxWidth;
            }

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            // Convert to JPEG (Base64) - reduced quality for speed
            const dataUrl = canvas.toDataURL('image/jpeg', 0.85);

            // Cleanup if we created a temporary URL
            if (isBlob) {
                URL.revokeObjectURL(url);
            }

            resolve(dataUrl);
        };

        img.onerror = () => {
            if (isBlob) {
                URL.revokeObjectURL(url);
            }
            reject(new Error('Failed to load image for resizing.'));
        };
    });
};

/**
 * Extracts raw Base64 string from a Data URL (removes "data:image/x;base64," header).
 */
export const extractBase64 = (dataUrl) => {
    return dataUrl.split(',')[1];
};
